









































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import CalendarEventData from '@/ts/CalendarEventData';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import moment from 'moment';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        FlexibleTable,
    },
})
export default class EventList extends Mixins(DateMethods) {
    public tableEntity: string = 'EventList';
    public eventDropdown: boolean = false;
    public eventDropdownIndex: number = -1;

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.event-id', 'Event ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'title', label: this.$t('general.title-uppercase', 'Title'), align: 'left', field: 'title', sortable: true, required: false },
            { name: 'eventTime', label: this.$t('general.event-time', 'Event time'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  this.eventTime(row),
            },
            { name: 'projects', label: this.$t('general.projects', 'Projects'), align: 'left', sortable: true, required: false, 
                field: 'projectNames', classes: 'hoc-event-table-column-xs', filterType: 'array',
            },
            { name: 'unitGroups', label: this.$t('general.unit-groups', 'Unit Groups'), align: 'left', sortable: true, required: false, 
                field: 'unitGroupNames', classes: 'hoc-event-table-column-xs', filterType: 'array',
            },
            { name: 'createdAt', label: this.$t('general.created-at', 'Created at'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  this.getLocalDateTimeString(row.createdAt),
            },
            { name: 'eventAddress', label: this.$t('general.address', 'Address'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  this.eventAddress(row),
            },
            { name: 'rsvp', label: this.$t('general.RSVP', 'RSVP'), align: 'left', sortable: true, required: false, filter: false,
                field: (row: any) =>  row.requiresResponse ? 'Yes' : 'No',
            },
            { name: 'recipients', label: this.$t('general.recipients', 'Recipient(s)'), align: 'left', field: 'recipients', sortable: true, required: false },
            { name: 'attenders', label: this.$t('general.attending', 'Attending'), align: 'left', field: 'attenders', sortable: true, required: false },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'title',
                'eventTime',
                'projects',
            ],
        };
    }

    get getCalendarEventData(): CalendarEventData[] {
        return this.$store.getters['Events/allEvents'];
    }

    public eventTime(event: any): string {
        const eventStart = this.getUTCISOstring(event.eventStart);
        const eventEnd = this.getUTCISOstring(event.eventEnd);

        const startDate = this.getLocalDateString(eventStart);
        const startTime = this.getLocalTimeString(eventStart);
        const endDate = this.getLocalDateString(eventEnd);
        const endTime = this.getLocalTimeString(eventEnd);

        if (startDate === endDate) {
            return startDate + ', ' + startTime + ' - ' + endTime;
        }

        return startDate + ', ' + startTime + ' - ' + endDate + ', ' + endTime;
    }

    public eventAddress(event: any): string {
        if (event.address === null) {
            return '';
        }

        const addressStreet = event.address.street;
        const addressCity = event.address.city;
        const addressZip = event.address.zip;

        if (event.address === null) {
            return ' - ';
        }

        return addressStreet + ', ' + addressCity + ', ' + addressZip;
    }

    public deleteEvent(id: number, title: string): void {
        this.closeDropDown();
        this.$store.commit(Mutations.SET_CONFIRM_POPUP_DATA, {
            confirmAction: 'Events/DELETE_EVENT',
            confirmActionData: { id },
            confirmQuestionText: this.$t('confirmation.are-you-sure-you-want-to-delete-this-event', 'Are you sure you want to delete this event?'),
            confirmInfoText: title,
            confirmButton: this.$t('forms.delete', 'Delete'),
            confirmButtonClass: 'hococo-close-form-btn',
        });
    }

    public slideInForm(formKey: string, itemId: any) {
        this.closeDropDown();
        this.$store.commit(Mutations.UPDATE_ACTIVE_EVENT, itemId);
        this.$store.commit(Mutations.EDIT_ACTIVE_EVENT);
        this.$store.commit(Mutations.SHOW_EDIT_EVENT_FORM, formKey);
    }

    public toggleEventDropdown(index: number) {
        if (index === this.eventDropdownIndex) {
            this.closeDropDown();
        } else {
            this.eventDropdown = this.eventDropdownIndex !== -1 ? true : !this.eventDropdown;
            this.eventDropdownIndex = index;
        }
    }

    public closeDropDown() {
        this.eventDropdown = false;
        this.eventDropdownIndex = -1;
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }

    public created() {
        window.addEventListener('click', this.closeDropDown);
    }
}
